import { render, staticRenderFns } from "./select-button-with-assignee-mandates.vue?vue&type=template&id=3f2bf19e&"
import script from "./select-button-with-assignee-mandates.vue?vue&type=script&lang=ts&"
export * from "./select-button-with-assignee-mandates.vue?vue&type=script&lang=ts&"
import style0 from "./select-button-with-assignee-mandates.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports